<template class="full-heigth">
  <!-- $t is vue-i18n global function to translate lang -->
  <div
    v-loading="listLoading"
    class="coupon-list-app-container full-heigth"
    style="position: relative; height: 100%"
  >
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-button icon="el-icon-refresh" type="info" @click="refreshCoupons"
          >重新整理清單</el-button
        >
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit" v-if="multipleSelection.length > 0"
          >確定選取</el-button
        >
      </el-form-item>
    </el-form>

    <div style="position: relative; height: 80%">
      <el-tag>共計{{ list.length }}張票券</el-tag>
      <el-table
        top="8%"
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="400"
        @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" type="selection" width="55"> </el-table-column>

        <!-- <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column> -->

        <el-table-column prop="sort" label="圖片" width="100" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 50px; height: 50px"
              :src="scope.row.fileInfo[0].files[0].url"
              fit="contain"
              :preview-src-list="[scope.row.fileInfo[0].files[0].url]"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" label="票券名稱" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.couponName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="票券地點" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.position }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="saveSingleCouon(scope.row)"
              >選取</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getCouponsWithTravelOutside, saveTravelCouponMapping } from '@/api/travel'
export default {
  name: 'CouponList',
  components: {},
  props: {
    fatherDialogFormVisible: {
      type: Function,
      default: () => null,
    },
    saveSuccess: {
      type: Function,
      default: () => null,
    },
    travelID: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      listLoading: false,
      list: [],
      multipleSelection: [],
    }
  },
  async activated() {},
  async created() {
    if (!this.chkTravelID()) {
      return
    }
  },
  mounted() {
    this.$nextTick(function () {})
  },
  methods: {
    async refreshCoupons() {
      await this.getCouponsWithTravelOutside()
    },
    async chkTravelID() {
      if (!this.travelID) {
        this.fatherDialogFormVisible(false)
        alert('未取得旅遊行程ID 無法選取票券。')
        return false
      }
      await this.getCouponsWithTravelOutside()
      return true
    },
    async saveSingleCouon(row) {
      if (!confirm(`確定選擇選取的票券?`)) {
        return false
      }
      let vm = this
      let ids = [row.id]
      let payload = {
        travelID: vm.travelID,
        couponIDs: ids,
      }
      await vm.saveDataHandler(payload)
    },
    async onSubmit() {
      if (!confirm(`確定選擇選取的票券?`)) {
        return false
      }
      let vm = this
      let ids = []
      vm.multipleSelection.forEach((f, index) => {
        ids.push(f.id)
      })
      let payload = {
        travelID: vm.travelID,
        couponIDs: ids,
      }

      await vm.saveDataHandler(payload)
    },
    async saveDataHandler(payload) {
      let vm = this

      vm.listLoading = true

      await saveTravelCouponMapping(payload)
      await this.getCouponsWithTravelOutside()
      await vm.saveSuccess()

      vm.listLoading = false
      this.$message({
        message: '資料處理完成',
        type: 'success',
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    async getCouponsWithTravelOutside() {
      this.listLoading = true
      let res = await getCouponsWithTravelOutside()
      this.list = res.data
      this.listLoading = false
    },
  },
}
</script>

<style>
.full-heigth {
  position: relative;
  height: 100%;
}
</style>
